import React from "react";

function TabHeader(props) {
  const { item, idx, activeTabId, onClick, isVertical = true } = props || {};
  const Clicked = () => {
    onClick(idx);
  };

  const layout = isVertical ? "vertical" : "horizontal";
  const orientationOpts = {
    vertical: {
      default: "text-black-lighter tracking-tabheading",
      inactive:
        "dark:text-gray-lighter relative border-l-1 border-black-lighter dark:border-gray-lighter font-medium ",
      active:
        "border-l-1 dark:text-white relative before:content-[''] before:absolute before:block before:h-full before:bg-red-light before:dark:bg-green-standard before:top-0 before:-left-1 before:w-1 font-bold"
    },
    horizontal: {
      default:
        "text-black-lighter tracking-widest whitespace-nowrap  max-h-12 sm:max-h-auto ",
      inactive: "relative font-medium dark:text-gray-lighter",
      active:
        "dark:text-white font-bold relative before:content-[''] before:absolute before:block before:h-1 before:w-full before:bg-red-light before:dark:bg-green-standard before:-bottom-1 before:left-0"
    }
  };
  return (
    <div
      key={idx}
      className={`${idx === activeTabId ? orientationOpts[layout]?.active : orientationOpts[layout]?.inactive}
            ${orientationOpts[layout]?.default}
            px-4 py-3 md:!mr-0 text-xs md:text-[0.85rem] leading-[1.35rem] font-tabheading uppercase 
            cursor-pointer `}
      onClick={Clicked}
    >
      {item?.tabIcon && <>{item?.tabIcon}</>}
      <div dangerouslySetInnerHTML={{ __html: item?.title }} />
      {item?.tabState?.toLowerCase() === "new" && (
        <span
          className={`${idx === activeTabId ? "text-yellow-lighten dark:text-green-standard" : "text-gray-darken"} pl-2 uppercase h7 new-state`}
        >
          New
        </span>
      )}
    </div>
  );
}

export default TabHeader;
